//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import { mapGetters } from 'vuex'
import qs from 'qs'
import wcs from '@/scripts/libs/wcs'
import { CATALOG_ID, LANG_ID, STORE_ID } from '@/scripts/constants/parameters'
import { EVENTS } from '@/scripts/constants/css-classes'
import { WcsGetSupport } from '@/scripts/libs/wcs/get-support'

export default {
  name: 'rb-get-support-search-bar',

  props: {
    previouslySearchedQuery: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'dark',
    },
  },

  data() {
    return {
      query: '',
      searchData: [],
      hasSuggestions: false,
      activeItemIndex: -1,
      firstTime: true,
      searchedForLabel: this.previouslySearchedQuery,
    }
  },

  computed: {
    ...mapGetters(['translation']),
    suggestions() {
      return (
        this.searchData &&
        this.searchData.filter((el) => {
          const name = el.name.toLowerCase()
          const query = this.query ? this.query.toLowerCase() : ''
          if (name.startsWith(query) && name !== query) {
            el.highlights = `<span><span class="matching">${el.name.slice(
              0,
              query.length
            )}</span>${el.name.slice(query.length)}</span>`
            return true
          }
          return false
        })
      )
    },

    isSuggestionListOpen() {
      return this.activeItemIndex >= 0
    },

    isNotEmpty() {
      return this.query && this.query.length > 0
    },
  },

  watch: {
    suggestions() {
      if (!this.suggestions) {
        return
      }
      if (this.firstTime) {
        this.firstTime = false
        return
      }
      this.hasSuggestions = this.isNotEmpty && this.suggestions.length > 0

      if (!this.hasSuggestions) {
        this.activeItemIndex = -1
      }

      if (this.activeItemIndex >= this.suggestions.length) {
        this.activeItemIndex = this.suggestions.length - 1
      }
    },
  },

  mounted() {
    document.body.addEventListener(EVENTS.CLICK, this.onPageClick)
    this.getSearchSuggestionList()
    const queryParams = qs.parse(window.location.search)
    const searchTerm = get(queryParams, '?searchTerm', null)
    if (!searchTerm) {
      this.firstTime = false
    }
    this.query = searchTerm
      ? searchTerm
      : this.previouslySearchedQuery
      ? this.previouslySearchedQuery
      : ''
  },

  beforeDestroy() {
    document.body.removeEventListener(EVENTS.CLICK, this.onPageClick)
  },

  methods: {
    async getSearchSuggestionList() {
      const response = await WcsGetSupport.getSearchSuggestion()
      this.searchData = response
    },

    resetSearchedQueryLabel() {
      this.searchedForLabel = ''
    },

    chooseSuggestionFromList(index) {
      this.query = this.suggestions[index] ? this.suggestions[index].name : ''
      this.closeList()
    },

    closeList(focusQuery = true) {
      this.$refs.suggestions.style.display = 'none'
      this.hasSuggestions = false
      this.activeItemIndex = -1

      focusQuery && this.$refs.query.focus()
    },

    onPageClick(e) {
      if (e.target !== this.$refs.query) {
        this.closeList(false)
      }
    },

    navigateList(e) {
      switch (e.key) {
        case 'ArrowDown':
          this.activeItemIndex < this.suggestions.length - 1 && this.activeItemIndex++
          break

        case 'ArrowUp':
          this.activeItemIndex > 0 && this.activeItemIndex--
          break

        case 'Enter':
          if (this.$refs.suggestions.children[this.activeItemIndex]) {
            this.query = this.$refs.suggestions.children[this.activeItemIndex].dataset.value
          }
          this.isSuggestionListOpen ? this.closeList() : this.submitSearch()
          break
      }
    },

    submitSearch() {
      this.closeList(false)
      const { storeId, catalogId, langId } = wcs.getStoreConfig()
      const redirect = `${window.origin}/SupportSearchView?searchTerm=${this.query}&${LANG_ID}=${langId}&${CATALOG_ID}=${catalogId}&${STORE_ID}=${storeId}`
      window.location.href = redirect
    },
  },
}
